import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/** Scrolls window to top on every route change. */
export default function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    // Use "instant" to avoid a jarring animated scroll on navigation
    try {
      window.scrollTo({ top: 0, left: 0, behavior: "instant" });
    } catch {
      window.scrollTo(0, 0);
    }
  }, [pathname]);
  return null;
}
